import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "text-grey ml-2"
};
const _hoisted_2 = {
    key: 2,
    class: "text-grey"
};
const _hoisted_3 = { key: 0 };
import { onBeforeMount, reactive, ref } from "vue";
import { useSettingsStore } from "@/stores/SettingsStore";
import { storeToRefs } from "pinia";
import axios from "axios";
import { useMessageStore } from "@/stores/MessageStore";
import { Formatter } from "@/util/Formatter";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PaymentSettingsView',
    setup(__props) {
        const settingsDirtyState = reactive(new Set());
        const messageStore = useMessageStore();
        const settingsStore = useSettingsStore();
        const { settings, loadedPrivate } = storeToRefs(useSettingsStore());
        let saveInFlight = ref(false);
        let connectInFlight = ref(false);
        let statusLoading = ref(true);
        let sumupStatus = ref(null);
        let form = ref(null);
        onBeforeMount(() => {
            if (!loadedPrivate.value) {
                settingsStore.loadPrivateSettings();
            }
            axios.get('/sumup/status', { withCredentials: true })
                .then((response) => {
                sumupStatus.value = response.data;
            })
                .finally(() => {
                statusLoading.value = false;
            });
        });
        function onSwitchChanged(value, key) {
            settings.value.get(key).value = value ? 'true' : 'false';
            settingsDirtyState.add(key);
        }
        function atLeastOnePaymentMethodRule() {
            const paymentKeys = ['payment_bank_transfer_enabled', 'payment_cash_enabled', 'payment_sumup_enabled'];
            const enabled = paymentKeys.some(key => settings.value.get(key)?.value === 'true');
            return enabled || 'Es muss mindestens eine Zahlungsart aktiviert sein.';
        }
        async function save() {
            const { valid } = await form.value.validate();
            if (!valid)
                return;
            saveInFlight.value = true;
            const promises = [];
            settingsDirtyState.forEach(dirtyKey => {
                promises.push(settingsStore.upload(dirtyKey));
            });
            Promise.all(promises).then(() => {
                messageStore.addMessage("Erfolgreich gespeichert");
            }).finally(() => {
                saveInFlight.value = false;
            });
        }
        function connectSumUp() {
            connectInFlight.value = true;
            axios.get('/sumup/connect', { withCredentials: true })
                .then(response => {
                window.location.href = process.env.VUE_APP_API_URL + response.data;
            })
                .catch(() => {
                messageStore.addError("Fehler beim Verbinden mit SumUp");
            })
                .finally(() => {
                connectInFlight.value = false;
            });
        }
        return (_ctx, _cache) => {
            const _component_v_container = _resolveComponent("v-container");
            const _component_v_divider = _resolveComponent("v-divider");
            const _component_v_progress_circular = _resolveComponent("v-progress-circular");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_card = _resolveComponent("v-card");
            const _component_v_switch = _resolveComponent("v-switch");
            const _component_v_form = _resolveComponent("v-form");
            return (_openBlock(), _createBlock(_component_v_card, null, {
                default: _withCtx(() => [
                    _createVNode(_component_v_form, {
                        ref_key: "form",
                        ref: form
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_container, {
                                fluid: true,
                                class: "d-flex flex-wrap ma-0 pa-0"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_container, { class: "text-h4 text-start v-col-12" }, {
                                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                                            _createTextVNode(" Zahlungseinstellungen ")
                                        ])),
                                        _: 1
                                    }),
                                    _createVNode(_component_v_container, { class: "d-flex flex-wrap v-col-12" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_card, {
                                                class: "mr-4 mb-4 pa-4",
                                                "min-width": "400px"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_container, { class: "text-start font-weight-bold v-col-12 pa-0 pb-2" }, {
                                                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                                                            _createTextVNode("SumUp Integration")
                                                        ])),
                                                        _: 1
                                                    }),
                                                    _createVNode(_component_v_divider, { class: "mb-4" }),
                                                    _createVNode(_component_v_container, { class: "pa-0" }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_v_container, { class: "pa-0 pb-2 text-start" }, {
                                                                default: _withCtx(() => [
                                                                    _cache[6] || (_cache[6] = _createElementVNode("span", { class: "font-weight-bold" }, "Status: ", -1)),
                                                                    (_unref(statusLoading))
                                                                        ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                                                            key: 0,
                                                                            indeterminate: true,
                                                                            size: "16",
                                                                            width: "2",
                                                                            class: "ml-1"
                                                                        }))
                                                                        : (_unref(sumupStatus)?.connected)
                                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-success" }, "Verbunden", -1)),
                                                                                (_unref(sumupStatus).refreshTokenExpiresAt)
                                                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, " (gültig bis " + _toDisplayString(_unref(Formatter).date(new Date((_unref(sumupStatus)).refreshTokenExpiresAt))) + ") ", 1))
                                                                                    : _createCommentVNode("", true)
                                                                            ], 64))
                                                                            : (_openBlock(), _createElementBlock("span", _hoisted_2, "Nicht verbunden"))
                                                                ]),
                                                                _: 1
                                                            }),
                                                            _createVNode(_component_v_container, { class: "pa-0 pb-2 text-start" }, {
                                                                default: _withCtx(() => [
                                                                    _cache[7] || (_cache[7] = _createElementVNode("span", { class: "font-weight-bold" }, "Händler-Code: ", -1)),
                                                                    _createElementVNode("span", {
                                                                        class: _normalizeClass({ 'text-error': !_unref(sumupStatus)?.merchantCode })
                                                                    }, _toDisplayString(_unref(sumupStatus)?.merchantCode ?? 'Unbekannt'), 3)
                                                                ]),
                                                                _: 1
                                                            }),
                                                            _createVNode(_component_v_btn, {
                                                                onClick: connectSumUp,
                                                                loading: _unref(connectInFlight)
                                                            }, {
                                                                default: _withCtx(() => _cache[8] || (_cache[8] = [
                                                                    _createTextVNode(" Mit SumUp verbinden ")
                                                                ])),
                                                                _: 1
                                                            }, 8, ["loading"])
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1
                                            }),
                                            (_unref(loadedPrivate))
                                                ? (_openBlock(), _createBlock(_component_v_card, {
                                                    key: 0,
                                                    class: "mr-4 mb-4 pa-4",
                                                    "min-width": "400px"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_container, { class: "text-start font-weight-bold v-col-12 pa-0 pb-2" }, {
                                                            default: _withCtx(() => _cache[9] || (_cache[9] = [
                                                                _createTextVNode("Zahlungsarten für Kunden")
                                                            ])),
                                                            _: 1
                                                        }),
                                                        _createVNode(_component_v_divider, { class: "mb-2" }),
                                                        _createVNode(_component_v_switch, {
                                                            density: "compact",
                                                            "model-value": _unref(settings).get('payment_bank_transfer_enabled')?.value === 'true',
                                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = (v) => onSwitchChanged(v, 'payment_bank_transfer_enabled')),
                                                            label: "Vorkasse / Überweisung",
                                                            color: "primary",
                                                            "hide-details": "auto",
                                                            rules: [atLeastOnePaymentMethodRule]
                                                        }, null, 8, ["model-value", "rules"]),
                                                        _createVNode(_component_v_switch, {
                                                            density: "compact",
                                                            "model-value": _unref(settings).get('payment_cash_enabled')?.value === 'true',
                                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = (v) => onSwitchChanged(v, 'payment_cash_enabled')),
                                                            label: "Vor Ort",
                                                            color: "primary",
                                                            "hide-details": "auto",
                                                            rules: [atLeastOnePaymentMethodRule]
                                                        }, null, 8, ["model-value", "rules"]),
                                                        _createVNode(_component_v_switch, {
                                                            density: "compact",
                                                            "model-value": _unref(settings).get('payment_sumup_enabled')?.value === 'true',
                                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = (v) => onSwitchChanged(v, 'payment_sumup_enabled')),
                                                            label: "Kredit- / Debitkarte (SumUp)",
                                                            color: "primary",
                                                            "hide-details": "auto",
                                                            rules: [atLeastOnePaymentMethodRule],
                                                            disabled: !_unref(sumupStatus)?.connected
                                                        }, null, 8, ["model-value", "rules", "disabled"])
                                                    ]),
                                                    _: 1
                                                }))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_v_btn, {
                                        onClick: save,
                                        class: "ml-4 mb-4"
                                    }, {
                                        default: _withCtx(() => [
                                            (!_unref(saveInFlight))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Speichern"))
                                                : _createCommentVNode("", true),
                                            (_unref(saveInFlight))
                                                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                                    key: 1,
                                                    indeterminate: true
                                                }))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }, 512)
                ]),
                _: 1
            }));
        };
    }
});
